import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import FavouriteButtonActive from '../../../assets/icons/FavouriteButtonActive.svg';
import FavouriteButtonDisabled from '../../../assets/icons/FavouriteButtonDisabled.svg';

const FavouriteButton = ({
    isFavourite,
    onClick,
    size = 50,
    iconSize = size,
    sx = {},
    tooltipTitle = 'Favourite',
}) => {
    const button = (
        <IconButton
            onClick={onClick}
            sx={{
                width: size,
                height: size,
                p: 0,
                flexShrink: 0,
                ...sx,
            }}
            aria-label={isFavourite ? 'Remove from favourites' : 'Add to favourites'}
        >
            <img
                src={isFavourite ? FavouriteButtonActive : FavouriteButtonDisabled}
                alt=""
                style={{ width: iconSize, height: iconSize }}
            />
        </IconButton>
    );

    if (!tooltipTitle) return button;
    return (
        <Tooltip title={tooltipTitle} arrow>
            {button}
        </Tooltip>
    );
};

export default FavouriteButton;
